import React from "react";
import "../FBOHome.css";
import { Link, useNavigate } from "react-router-dom";
import ROUTE_PATHS from "../../../utils/routePaths";
import { FBO_TYPE } from "../../../utils/constants";
import GridComponent from "../Views/GridComponent";
import NavigationBar from "../../../components/element/NavigationBar";
import FBOHeaderBar from "../../../components/element/FBOHeaderBar";
import invoicingIcon from "../../../assets/images/reports-icon.svg";
import viewDataIcon from "../../../assets/images/view-data-icon.svg";

const LandingFeeHome = () => {
  const navigate = useNavigate();
  const gridItems = [
    {
      title: "View Data",
      icon: viewDataIcon,
      width: 23,
      height: 28,
    },
    { title: "Invoices", icon: invoicingIcon, width: 23, height: 28 },
  ];

  const handleCardOnClick = (index) => {
    if (index === 0) {
      navigate(ROUTE_PATHS.LANDING_FEE_DATA);
    } else if (index === 1) {
      navigate(ROUTE_PATHS.INVOICES.replace(":aboType", FBO_TYPE.LANDING_FEE));
    }
  };

  return (
    <div>
      <NavigationBar />
      <FBOHeaderBar
        title={"Landing Fee"}
        backContent={
          <div className="navigation-header">
            <Link to={ROUTE_PATHS.FBO_HOME} className="navigation-header-link">
              Home/
            </Link>
            Landing Fee
          </div>
        }
      />
      <div className="fee-type-home-container">
        <GridComponent gridItems={gridItems} onClickCard={handleCardOnClick} />
      </div>
    </div>
  );
};

export default LandingFeeHome;
